import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const PageHero = ({ title, subtitle, crumb }) => {
  return (
    <section className="relative bg-brand-navy overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-brand-navy via-brand-slate to-brand-navy" />
      <div className="absolute -top-20 -right-20 w-80 h-80 bg-brand-orange/10 rounded-full blur-3xl" />
      <div className="relative max-w-7xl mx-auto px-6 py-16 md:py-20 text-center">
        <div className="flex items-center justify-center gap-2 text-sm text-white/60 mb-4">
          <Link to="/" className="hover:text-brand-orange transition-colors">
            Home
          </Link>
          <ChevronRight className="w-4 h-4" />
          <span className="text-brand-orange">{crumb || title}</span>
        </div>
        <h1 className="font-display font-extrabold text-white text-4xl md:text-5xl">
          {title}
        </h1>
        {subtitle && (
          <p className="text-white/75 text-lg mt-4 max-w-2xl mx-auto leading-relaxed">
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
};

export default PageHero;
